import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import RuleHandler from 'handlers/rule.handler';
import { type Notification } from 'types/notification.types';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export {};

/**
 *
 * The Delete rule modal.
 */

interface Props {
  open: boolean;
  rule: Notification;
  handleAbort: () => void;
  enableDarkTheme: boolean;
}

export const DeleteRuleModal = ({
  open,
  rule,
  handleAbort,
  enableDarkTheme,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const ruleHandler = new RuleHandler();
  const title = `Delete Rule ${rule.ruleName}`;
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await ruleHandler.softDeleteRule(rule.ruleId);
          handleAbort();
        },
        disabled: false,
        label: t('delete_rule'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
      enableDarkTheme={enableDarkTheme}
    >
      <Typography
        sx={{
          color: palette.textPrimary,
          fontSize: '14px',
        }}
        key="blurb-1"
      >
        {t('please_confirm_that_you_want_to_delete_this_rule')}
      </Typography>
      <Typography key="blurb-2" variant="small"></Typography>
    </InteractiveModal>
  );
};
